<template>
  <Dialog
    :visible="showDialog"
    :style="{ width: '450px' }"
    :header="add ? 'Agregar Unidad' : 'Editar Unidad'"
    :modal="true"
    class="p-fluid"
    @update:visible="hideDialog"
    @hide="hideDialog"
  >
    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
      <form role="form" @submit.prevent="handleSubmit(submitForm)">
        <base-input
          v-model="innerValue.unity_name"
          rules="required|min:3"
          label="Nombre"
          name="Nombre"
          type="text"
        />
        <base-input
          v-model="innerValue.unity_orden"
          rules="required|min_value:1"
          label="Orden"
          name="Orden"
          type="number"
        />
        <div class="p-d-flex">
          <Button
            label="Cancelar"
            icon="pi pi-times"
            class="p-button-text mx-2"
            type="button"
            @click="hideDialog"
          />
          <Button
            class="mx-2"
            label="Guardar"
            icon="pi pi-check"
            type="submit"
          />
        </div>
      </form>
    </ValidationObserver>
  </Dialog>
</template>

<script>
import unityService from "@/services/axios/units.service";
export default {
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    add: {
      type: Boolean,
      default: true,
    },
    moduleId: {
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      innerValue: {
        unity_name: "",
        unity_description: "",
        teacher: "",
        unity_code: "",
      },
    };
  },
  watch: {
    value(newVal) {
      this.innerValue = { ...newVal, module_id: this.moduleId };
    },
  },
  methods: {
    hideDialog() {
      this.$emit("close");
    },
    submitForm() {
      if (this.add) this.saveUnity();
      else this.updateUnity();
    },
    saveUnity() {
      unityService
        .save(this.innerValue)
        .then(({ data }) => {
          this.$emit("setUnits", data);
          this.$swal({
            icon: "success",
            text: `Unidad creada correctamente`,
          });
        })
        .catch((error) => {
          this.$swal({
            icon: "error",
            title: `Error`,
            text: error.response.data.error,
          });
        });
    },
    updateUnity() {
      unityService
        .update(this.innerValue.id, this.innerValue)
        .then(({ data }) => {
          this.$emit("setUnits", data);
          this.$swal({
            icon: "success",
            text: `Unidad editada correctamente`,
          });
        })
        .catch((error) => {
          this.$swal({
            icon: "error",
            title: `Error`,
            text: error.response.data.error,
          });
        });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Unidad/UnityDialog.vue